var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Advantage"},[_c('ui-sidebar'),_vm._v(" "),_c('div',{staticClass:"rightBox clearfix"},[_c('ui-topbar',{staticClass:"d-none d-lg-block"}),_vm._v(" "),_c('ui-center'),_vm._v(" "),_c('ui-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a341c37c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/advantage/Advantage.vue
// module id = null
// module chunks = 